module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer-desc"
  }, [_c('p', {
    staticClass: "cooper"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("合作伙伴 - 中国针织工业协会花边分会")]), _vm._v("|\n      "), _c('span', {
    staticClass: "text"
  }, [_vm._v("指导单位：长乐市纺织局")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "text"
  }, [_vm._v("新闻合作媒体 - 腾讯财经")]), _vm._v("|\n      "), _c('span', {
    staticClass: "text"
  }, [_vm._v("东方财富网")])])]), _vm._v(" "), _c('div', {
    staticClass: "footer-cropy"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("©福建省长乐市坐视布管网络科技有限公司　闽ICP备14005607号-1")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-75096d10"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer/footer.vue
// module id = 845
// module chunks = 39